import { GlobalDataContext } from "@/app/context/global/globalDataContext";
import MyCreatures from "@/app/layout/game/myCreatures";
import Header from "@/app/layout/global/header";
import { Button, Link, Text } from "@chakra-ui/react";
import NextLink from "next/link";
import { useContext, useMemo } from "react";
import { FriendsContext } from "@/app/context/friends/friendsContext";
import { AuthenticationContext } from "@/app/context/authentication/authenticationContext";
import { GameFriendsScore } from "@/app/context/friends/layout/gameFriendsScore";
import { keyframes } from '@emotion/react';
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext";
import Footer from "@/app/layout/global/footer";
import { buildChaseUrl } from "@/app/helpers/buildUrlHelper";
import { v4 } from "uuid";
import { useTranslation } from "next-i18next";
import MenuContent from "../global/menuContent";
import Skeleton from "../global/skeleton";
import { BodyHead } from "../global/bodyHead";
import MyEggs from "../game/myEggs";

const zoomAndShake = keyframes`
   0% {
    transform: scale(0) ;
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1) ;
    opacity: 1;
  }
  100% {
    transform: scale(1) ;
  }
`;


export default function EggsLayout() {
    const { t } = useTranslation();
    const uuid = v4()
    
    const {
        language,
        categoryId,
    } = useContext(GlobalDataContext)
    
    const {
        friendRequestWithUser,
    } = useContext(FriendsContext)
    
    const {
        user,
    } = useContext(AuthenticationContext)
    
    const {
        myCreatures,
        myItems
    } = useContext(GlobalDataUserContext)
    
    const chaseUrl = useMemo(() => buildChaseUrl(language, categoryId, uuid), [language, categoryId, uuid]);

    return(
        <>
            <BodyHead
                url={process.env.NEXT_PUBLIC_URL as string}
                mainTitle={t("home.title")}
                title={t("home.titleBody")}
                description={t("home.descriptionBody")}
            />
            <Skeleton
                background={<MyEggs shadow={true}/>}
                header={<Header title={t("menu.myEggs")} /> }
                menu={<MenuContent/>}
                friends={<>{user && user.email && <GameFriendsScore friends={friendRequestWithUser}/> }</>}
                footer={<Footer/>}
            >
                <>
                    <Text px={5} pb={2} opacity={0.5} textAlign="right" size="sm" color="white">{myItems?.length || 0} {t("eggs.eggs")}</Text>
                    <MyEggs/>
                </>
            </Skeleton>
            
        </>
    )

}